export const SeeMoreIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="14" viewBox="0 0 4 14" fill="none">
      <path
        d="M2.00016 7.66675C2.36835 7.66675 2.66683 7.36827 2.66683 7.00008C2.66683 6.63189 2.36835 6.33341 2.00016 6.33341C1.63197 6.33341 1.3335 6.63189 1.3335 7.00008C1.3335 7.36827 1.63197 7.66675 2.00016 7.66675Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.00016 3.00008C2.36835 3.00008 2.66683 2.7016 2.66683 2.33341C2.66683 1.96522 2.36835 1.66675 2.00016 1.66675C1.63197 1.66675 1.3335 1.96522 1.3335 2.33341C1.3335 2.7016 1.63197 3.00008 2.00016 3.00008Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.00016 12.3334C2.36835 12.3334 2.66683 12.0349 2.66683 11.6667C2.66683 11.2986 2.36835 11.0001 2.00016 11.0001C1.63197 11.0001 1.3335 11.2986 1.3335 11.6667C1.3335 12.0349 1.63197 12.3334 2.00016 12.3334Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
